import { Account } from './AccountModel';

export class Session {
  public currentWorkingAccount?: Account;

  constructor(obj: Session = {} as Session) {
    Object.assign(this, obj);
  }
}